var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-5 py-3 rounded-xl shadow",attrs:{"flat":"","dark":_vm.dark}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }